
const TAB_MAIN = 0;
const TAB_PACKETS = 1;
const TAB_JACKPOTS = 2;
const TAB_REPORTS = 4;
const TAB_DENOMINATION = 5;
const TAB_API = 6;
const TAB_WAGER = 7;

export { TAB_MAIN, TAB_PACKETS, TAB_JACKPOTS, TAB_REPORTS, TAB_DENOMINATION, TAB_API, TAB_WAGER };